
import Moderator from '@/models/bread/Moderator/playerMission'


export default {
  key:'Mission',
  name:{
    singular:'Mission',
    plural:'Missions',
  },
  parents:[
    'Player',
  ],
  grandParents:[
  ],
  Admin:false,
  Moderator:Moderator,
  Teacher:false,
}